module.exports = __webpack_public_path__ + "static/media/avatar copy.dee7e82c.png";